import React, { useState, useEffect, useRef } from "react";
import { Box, Typography, Tabs, Tab } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { disconnectWebsocket } from "../../../../store/actions/websocketActions";
import UploadedForms from "./tabs/UploadedForms";
import NewForm from "./tabs/NewForm";
import FormManagementPopup from "./components/FormManagementPopup";

const FormsManagementPage = () => {
  const currentSession = useSelector((state) => state.sessions.currentSession);
  const currentUser = useSelector((state) => state[currentSession].user);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // State management
  const [activeTab, setActiveTab] = useState(0);
  const [popupState, setPopupState] = useState({
    open: false,
    severity: "info",
    message: "",
  });

  const dispatchCount = useRef(0);

  // Check admin access
  useEffect(() => {
    if (currentUser?.user) {
      if (currentUser?.user?.role !== "admin" || !currentUser?.user?.admin) {
        if (dispatchCount.current < 1) {
          dispatch(disconnectWebsocket(currentSession));
          navigate("/login");
          dispatchCount.current += 1;
        }
      }
    }
  }, [currentUser?.user, dispatch, currentSession, navigate]);

  // Handle tab change
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  // Handle messages from child components
  const handleError = (errorMessage) => {
    setPopupState({ open: true, severity: "error", message: errorMessage });
  };

  const handleSuccess = (successMessage) => {
    setPopupState({ open: true, severity: "success", message: successMessage });
  };

  const handleNotify = (severity, message) => {
    setPopupState({ open: true, severity, message });
  };

  const handlePopupClose = (_, reason) => {
    if (reason === "clickaway") return;
    setPopupState((prev) => ({ ...prev, open: false }));
  };

  if (
    !currentUser ||
    currentUser?.user?.role !== "admin" ||
    !currentUser?.user?.admin
  ) {
    return null;
  }

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" color="primary" component="h1" sx={{ mb: 3 }}>
        Forms Management
      </Typography>

      <FormManagementPopup
        open={popupState.open}
        severity={popupState.severity}
        message={popupState.message}
        onClose={handlePopupClose}
        autoHideDuration={3000}
      />

      <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}>
        <Tabs value={activeTab} onChange={handleTabChange}>
          <Tab label="Uploaded Forms" />
          <Tab label="New Form" />
        </Tabs>
      </Box>

      {activeTab === 0 && (
        <UploadedForms
          onError={handleError}
          onSuccess={handleSuccess}
          onNotify={handleNotify}
          currentSession={currentSession}
        />
      )}

      {activeTab === 1 && (
        <NewForm
          onError={handleError}
          onSuccess={handleSuccess}
          currentSession={currentSession}
        />
      )}
    </Box>
  );
};

export default FormsManagementPage;
